'use strict';

var i18n = require('i18next');
var ConfigClone = require('actions/configClone/ConfigClone');
var FormView = require('actions/configClone/FormView');
var StaticView = require('actions/configClone/StaticView');

/**
 * Action configuration for Config Clone
 */
module.exports = {
  title: i18n.t('configClone.title'),
  Model: ConfigClone,
  FormView: FormView,
  TextView: StaticView,
};
